import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-reload',
  templateUrl: './reload.component.html',
  styleUrls: ['./reload.component.scss']
})
export class ReloadComponent implements OnInit {

  ngOnInit() {
    history.go(-1);
  }
}
